import { newId } from '@/utils/id'

// Identificação do dispositivo de quem responde questionários: um id aleatório guardado
// no navegador (localStorage). Não é à prova de fraude (aba anônima ou limpar os dados
// gera outro), mas permite reconhecer envios com nomes diferentes vindos do mesmo aparelho
// e reaproveitar o último nome de usuário digitado.
const DEVICE_KEY = 'quiz_device_id'
const NAME_KEY = 'quiz_participant_name'

let memoryDeviceId = ''

export function getQuizDeviceId(): string {
  try {
    let id = window.localStorage.getItem(DEVICE_KEY) || ''
    if (!/^[A-Za-z0-9_-]{8,64}$/.test(id)) {
      id = newId('dev')
      window.localStorage.setItem(DEVICE_KEY, id)
    }
    return id
  } catch {
    // storage bloqueado: vale só para esta aba
    if (!memoryDeviceId) memoryDeviceId = newId('dev')
    return memoryDeviceId
  }
}

export function getSavedParticipantName(): string {
  try { return window.localStorage.getItem(NAME_KEY) || '' } catch { return '' }
}

export function saveParticipantName(name: string) {
  try { window.localStorage.setItem(NAME_KEY, name) } catch { /* ignore */ }
}

// Rótulo curto e estável para exibir o dispositivo nos resultados (ex.: "PC 3F9A1")
export function deviceLabel(deviceId: string): string {
  if (!deviceId) return ''
  return `PC ${deviceId.replace(/[^A-Za-z0-9]/g, '').slice(-5).toUpperCase()}`
}
